import { ChangeDetectionStrategy, ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ToastConfigService } from '@services';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { AuthService } from '../../../core/services/auth/auth.service';
import { SpinnerService } from '../../../core/services/spinner/spinner.service';
import { UtilityService } from '../../../core/services/utility/utility.service';
import { VideosService } from '../videos.service';

import { APP_SETTINGS } from '@services';
import { AnalyticsService } from '../../../core/services/analytics/analytics.service';
import { NgIf, NgFor, DatePipe } from '@angular/common';
import { RouterLink } from '@angular/router';
import { ShareContentComponent } from '../../share-content/share-content.component';
import { HighlightSearchPipe } from '../../../shared/pipes/highlight-search.pipe';

@Component({
    selector: 'app-videos-history',
    templateUrl: './videos-history.component.html',
    styleUrls: ['./videos-history.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgIf, NgFor, RouterLink, ShareContentComponent, DatePipe, HighlightSearchPipe]
})
export class VideosHistoryComponent implements OnInit {

  public screenWidth: any;
  public videoList: any;
  public dateFormat: string;
  private subscription: ISubscription[];

  username: string;
  public shareContentObject = {};

  public videoThumbnail =  APP_SETTINGS.isMINI === 'true' ? APP_SETTINGS.miniVideoThumbnail : APP_SETTINGS.isRollsRoyce === 'true' ? APP_SETTINGS.rollsRoyceVideoThumbnail : APP_SETTINGS.videoThumbnail;
  public videoThumbnailHeight = APP_SETTINGS.videoThumbnailHeight;
  public videoThumbnailWidth = APP_SETTINGS.videoThumbnailWidth;

  @ViewChild('modalCloseButton')
  private modalCloseButtonEle: ElementRef;

  constructor(private videoService: VideosService,
    private authService: AuthService,
    private spinnerService: SpinnerService,
    private utilityService: UtilityService,
    private analyticsService: AnalyticsService,
    private toastService: ToastConfigService,
    private cdr: ChangeDetectorRef) {
    this.screenWidth = this.utilityService.getScreenWidth();
  }

  ngOnInit() {
    this.subscription = [];
    this.username = this.authService.getUserName();
    this.dateFormat = 'yyyy-MM-dd';
    this.spinnerService.show('bmwSpinner');
    this.videoService.getUserWatchHistory(this.username).subscribe(value => {
      this.spinnerService.hide('bmwSpinner');
      this.videoList = value;
      this.cdr.markForCheck();
    });
    this.subscription=[];
    this.subscription.push(this.utilityService.shareContentPopup$.subscribe(data => {
      if (typeof data === 'boolean') {
        this.modalCloseButtonEle.nativeElement.click();
      }
    }));
  }
  addVideoToWatchlist(videoId, videoDisplayNumber) {
     //Analytics call
     this.analyticsService.trackSavedContentByTypeLineMake('Videos', videoDisplayNumber, 'saved');
     //Analytics call
    this.videoService.addVideoToWatchlist(this.username, videoId).subscribe(data => {
      if (data) {
        this.toastService.popToast('Video added to watchlist');
      }
    });
  }
  shareContent(id, type, channel, videoDisplayNumber) {
    this.shareContentObject = {
      id: id,
      type: type,
      channel: channel,
      videoDisplayNumber:videoDisplayNumber
    };
  }

}
